import React from 'react';
import { Avatar } from '@mui/material';
import { DescriptionOutlined, LocationOnOutlined, PlayCircleOutline } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export const hasFinalScore = (match) => match.partidoJugado !== false &&
  [match.golesCasa, match.golesVisitante].every((value) =>
    value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0);

function dateLabel(value, language) {
  if (!value) return '';
  const text = String(value);
  const european = text.match(/^(\d{2})[-/](\d{2})[-/](\d{4})/);
  const iso = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  const date = european ? new Date(+european[3], +european[2] - 1, +european[1])
    : iso ? new Date(+iso[1], +iso[2] - 1, +iso[3]) : new Date(text);
  return Number.isNaN(date.getTime()) ? text : date.toLocaleDateString(language, { day: 'numeric', month: 'short' });
}

export default function FixtureCard({ match, highlights = [], onDetails, onReport, onLiveTag }) {
  const { t, i18n } = useTranslation('matches');
  const played = hasFinalScore(match);
  const teams = [
    { name: match.equipoLocal, crest: match.escudoEquipoLocal, goals: match.golesCasa },
    { name: match.equipoVisitante, crest: match.escudoEquipoVisitante, goals: match.golesVisitante },
  ];
  return <article className="pm-fixture-card" aria-label={`${match.equipoLocal} · ${match.equipoVisitante}`}>
    <header>
      <span>{[dateLabel(match.fecha, i18n.language), match.hora?.slice(0, 5)].filter(Boolean).join(' · ') || t('schedulePending')}</span>
      <span className={`pm-status ${played ? 'pm-status-finished' : ''}`}>{t(played ? 'status.finished' : 'status.scheduled')}</span>
    </header>
    <button type="button" className="pm-fixture-teams" onClick={onDetails}
      aria-label={t('fixtureDetails', { home: match.equipoLocal, away: match.equipoVisitante })}>
      {teams.map((team, index) => <span className="pm-fixture-team" key={index}>
        <Avatar src={team.crest || undefined} alt="" aria-hidden="true" className="pm-crest">
          {team.name?.split(/\s+/).map((word) => word[0]).slice(0, 2).join('')}
        </Avatar>
        <span>{team.name}</span><strong>{played ? team.goals : '—'}</strong>
      </span>)}
    </button>
    <p className="pm-fixture-venue"><LocationOnOutlined fontSize="inherit" />{match.estadio?.trim() || match.campo?.trim() || t('venuePending')}</p>
    {highlights.length > 0 && <div className="pm-fixture-highlights">
      {highlights.map((highlight) => <div key={highlight.type} className={`pm-highlight pm-highlight-${highlight.type}`}
        title={t(`highlights.${highlight.type}Rule`)}>
        <strong>{t(`highlights.${highlight.type}`)}</strong>
        <span>{t(highlight.type === 'titleDuel' ? 'highlights.titleReason'
          : `highlights.${highlight.result}Reason`, highlight)}</span>
      </div>)}
    </div>}
    <footer>
      <button type="button" onClick={onDetails}>{t(played ? 'viewActa' : 'viewDetail')}</button>
      {played && <button type="button" onClick={onReport} aria-label={t('reportAction')}>
        <DescriptionOutlined fontSize="small" />{t('report')}
      </button>}
      <button type="button" className={`pm-live-tag ${played ? '' : 'pm-live-tag-primary'}`} onClick={onLiveTag} aria-label={t('liveTag.tooltip')}>
        <PlayCircleOutline fontSize="small" />Live Tag
      </button>
    </footer>
  </article>;
}
